module.exports = __webpack_public_path__ + "img/Serial_Number.dea3a4c3.jpeg";